import React, { useState, useCallback, useEffect, useRef } from "react";
import FullCalendar, { EventClickArg } from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import { makeStyles, Theme } from "@material-ui/core";
import { Avatar } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import { useSelector, useDispatch } from "react-redux";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import CircularProgress from "@material-ui/core/CircularProgress";
import TimerIcon from "@material-ui/icons/Timer";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";

import {
  selectLoginUser,
  fetchAsyncLoginUser,
  selectSelectedProfile,
} from "../auth/authSlice";

import {
  fetchAsyncDeleteRecord,
  fetchAsyncGetRecords,
  selectRecords,
  selectDayRecords,
  addDayRecord,
  fetchAsyncGetMenu,
  // 選択日格納state
  selectSelectTargetDay,
  // 選択日格納action
  selectTargetDay,
  initialState,
  editRecord,
  selectRecord,
  fetchAsyncGetTargetMenu,
  selectSelectedUser,
  fetchAsyncGetFavoriteMenu,
  fetchAsyncGetTempRecords,
  fetchAsyncGetTimeRecord,
  selectTimeRecord,
  addIsQuickEditRecordFlg,
  fetchAsyncGetTempOriginalRecords,
  fetchAsyncGetOriginalRecords,
  selectOriginalRecords,
  fetchAsyncDeleteOriginalRecord,
  addDayOriginalRecord,
  selecDayOriginalRecords,
  selectTargetMenu,
} from "./homeSlice";
import {
  EVENT,
  GET_DATE_RECORD_PARAMETERS,
  ORIGINAL_RECORD,
  READ_RECORD,
} from "../../types/types";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#F1F9FF",
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    alignItems: "center",
    height: 48,
  },
  color: {
    color: "#2699FB",
  },
  listContainer: {
    margin: theme.spacing(1, 1),
    backgroundColor: "#fff",
    borderRadius: "5px",
    marginBottom: 60,
  },
  menuTitle: {
    "& span": {
      fontSize: 10,
    },
  },
  listItem: {
    marginBottom: theme.spacing(0.3),
    backgroundColor: "#F5F5F5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: 0,
    paddingLeft: theme.spacing(1),
    paddingTop: 3,
    paddingBottom: 3,
    minHeight: 54,
    "&:last-child": {
      marginBottom: theme.spacing(8),
    },
  },
  listItemSub: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  body: {
    fontSize: 10,
    paddingRight: theme.spacing(1),
  },
  calendar: {
    margin: theme.spacing(1),
    position: "relative",
  },
  back: {
    margin: theme.spacing(2),
    color: "#2699FB",
  },
  listHeight: {
    overflow: "auto",
    boxSizing: "border-box",
    paddingTop: 0,
    paddingBottom: 0,
  },
  avatar: {
    marginRight: theme.spacing(2),
    width: 30,
    height: 30,
  },
  avatarContainer: {
    paddingLeft: theme.spacing(2),
    fontSize: 10,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    backgroundColor: "rgba(237,238,255,0.5)",
    width: "90%",
    paddingBottom: 100,
    paddingTop: 50,
    borderRadius: 8,
  },
  modalItem: {
    width: "90%",
    margin: "0 auto",
  },
  modalText: {
    textAlign: "center",
    paddingBottom: 30,
    fontWeight: "bold",
    fontSize: 20,
  },
  modalBox: {
    paddingTop: 20,
    display: "flex",
    justifyContent: "space-around",
  },
  modalDeleteBtn: {
    width: 103,
  },
  day: {
    fontWeight: "bold",
    fontSize: 18,
  },
  arrowPrev: {
    left: 20,
    position: "absolute",
  },
  arrowNext: {
    right: 20,
    position: "absolute",
  },
  circulContainer: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    zIndex: 3,
  },
  timeContainer: {
    display: "flex",
    alignItems: "center",
  },
  addBtn: {
    color: "#ffffff",
    fontSize: 50,
  },
  addBtnContainer: {
    padding: 5,
    backgroundColor: "#2699FB",
    borderRadius: 35,
  },
  gridContainer: {
    height: "100vh",
  },
}));

const Home: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedProfile = useSelector(selectSelectedProfile);
  const records = useSelector(selectRecords);
  const dayRecords = useSelector(selectDayRecords);
  const loginUser = useSelector(selectLoginUser);
  const timeRecord = useSelector(selectTimeRecord);
  const originalRecords = useSelector(selectOriginalRecords);
  const dayOriginalRecords = useSelector(selecDayOriginalRecords);
  const [targetMonth, setTargetMonth] = useState("");
  const [today, setToday] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  //選択日付格納用
  const targetDay = useSelector(selectSelectTargetDay);
  const selectedUser = useSelector(selectSelectedUser);
  const [events, setEvents] = useState<EVENT[]>([
    {
      title: "",
      start: "",
      color: "",
    },
  ]);
  const [filterEvents, setFilterEvents] = useState<EVENT[]>([
    {
      title: "",
      start: "",
      color: "",
    },
  ]);
  const [currentMonthFirstDate, setCurrentMonthFirstDate] = useState<Date>(
    new Date()
  );
  const [tmpDayRecords, setTmpDayRecords] = useState<READ_RECORD[]>(
    initialState.dayRecords
  );
  const [tmpDayOriginalRecords, setTmpDayOriginalRecords] = useState<
    ORIGINAL_RECORD[]
  >(initialState.dayOriginalRecords);
  //modal用
  const [open, setOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({
    id: 0,
    title: "",
    text: "",
    menu_user_id: "",
  });

  //選択されている日付の背景設定用
  const [targetDayNumber, setTargetDayNumber] = useState(99);
  const isFirstRender = useRef(false);
  const backProfile = useCallback(() => {
    history.push("/home/profile");
  }, [history]);
  //record作成のため、recordBoardへ
  const handleClickAdd = useCallback(async () => {
    const para: GET_DATE_RECORD_PARAMETERS = {
      user_id: loginUser.id,
      date: targetDay,
    };
    await setIsLoading(true);
    // await dispatch(fetchAsyncGetMenu());
    await dispatch(fetchAsyncGetFavoriteMenu());
    await dispatch(fetchAsyncGetTempRecords(para));
    await dispatch(fetchAsyncGetTempOriginalRecords(para));
    await setIsLoading(false);
    await history.push("/home/record/board");
  }, [history, dispatch, loginUser, targetDay]);
  //modal用
  const handleDeleteModal = (record: READ_RECORD | ORIGINAL_RECORD) => {
    const weight = record.weight ? `${record.weight}kg` : "";
    const rep =
      record.number_value &&
      record.menu_type !== "time" &&
      record.menu_type !== "km"
        ? `${record.number_value}rep`
        : "";
    const min = record.menu_type === "time" ? `${record.number_value}min` : "";
    const set = record.set_value ? `${record.set_value}set` : "";
    const km = record.menu_type === "km" ? `${record.number_value}km` : "";
    const subText = `${weight} ${rep} ${min} ${km} ${set}`;
    setDeleteTarget({
      id: record.id,
      title: record.menu_title,
      text: subText,
      menu_user_id: record.menu_user_id,
    });
    setOpen(true);
  };
  const handleClose = () => {
    setDeleteTarget({ id: 0, title: "", text: "", menu_user_id: "" });
    setOpen(false);
  };

  //月初取得関数
  const getFirstDate = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };
  //月末取得関数
  const getLastDate = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };
  //対象日の曜日取得(0~6 ["日", "月", "火", "水", "木", "金", "土"])
  const getTargetDay = (date: Date) => {
    const dayOfWeek = date.getDay();
    return dayOfWeek;
  };
  const unsetSelectDateColor = () => {
    if (targetDayNumber === 99) {
      return;
    }
    const first_day_number = getTargetDay(currentMonthFirstDate);
    const current_date_element: HTMLElement = document.getElementsByClassName(
      "fc-daygrid-day"
    )[targetDayNumber + first_day_number] as HTMLElement;
    current_date_element.style.backgroundColor = "unset";
  };
  //レコードをeventsに格納する関数(現在のeventsを削除してから、新たにeventsをセットする)
  const eventsSet = useCallback(() => {
    setEvents([
      {
        title: "",
        start: "",
        color: "",
      },
    ]);
    records.map((record) =>
      setEvents((events) => [
        ...events,
        {
          title: record.menu_part,
          start: record.date,
          color: record.menu_color,
        },
      ])
    );
    originalRecords.map((record) =>
      setEvents((events) => [
        ...events,
        {
          title: record.menu_part,
          start: record.date,
          color: record.menu_color,
        },
      ])
    );
  }, [records, originalRecords]);
  //セットされたeventsの中から重複しているデータを削除(同日に胸胸　と表示されないよう)
  useEffect(() => {
    let array = events.filter(
      (element, index, self) =>
        self.findIndex(
          (e) => e.title === element.title && e.start === element.start
        ) === index
    );
    array = array.filter((item) => item.title.length > 0);
    setFilterEvents(array);
  }, [events]);

  //カレンダーの日付クリック時
  const handleClickDate = useCallback(
    async (e: DateClickArg | any) => {
      //初期表示以外の場合、現在選択されている日にちの背景をunsetする
      if (targetDayNumber !== 99) {
        //各月で1日が格納されているキーが異なるため、該当付きの初日の曜日を取得して、日付とキーを調整
        const first_day_number = getTargetDay(currentMonthFirstDate);
        const current_date_element: HTMLElement =
          document.getElementsByClassName("fc-daygrid-day")[
            targetDayNumber + first_day_number
          ] as HTMLElement;
        //今日の日付の場合背景を黄色のままにするように分岐
        if (
          Number(current_date_element.dataset.date?.slice(-2)) ===
          Number(today.slice(-2))
        ) {
          current_date_element.style.backgroundColor =
            "rgba(255, 220, 40, 0.15)";
        } else {
          current_date_element.style.backgroundColor = "unset";
        }
      }

      //新たに選択された日にちの背景を変更し、localStateに保存
      e.dayEl.style.backgroundColor = "#dbedff";
      const targetDay = Number(Number(e.dayEl.outerText.slice(0, 2)) - 1);
      if (selectedUser.user_profile === 0) {
        const para: GET_DATE_RECORD_PARAMETERS = {
          user_id: loginUser.id,
          date: e.dateStr,
        };
        await dispatch(fetchAsyncGetTimeRecord(para));
      }
      if (selectedUser.user_profile !== 0) {
        const para: GET_DATE_RECORD_PARAMETERS = {
          user_id: selectedUser.user_profile,
          date: e.dateStr,
        };
        await dispatch(fetchAsyncGetTimeRecord(para));
      }
      await setTargetDayNumber(targetDay);
      const newArray = records.filter((record) => record.date === e.dateStr);
      const newOriginalArray = originalRecords.filter(
        (record) => record.date === e.dateStr
      );
      await setTmpDayRecords(newArray);
      await setTmpDayOriginalRecords(newOriginalArray);
      await dispatch(selectTargetDay(e.dateStr));
    },
    [records, originalRecords, dispatch, targetDayNumber, targetMonth]
  );
  //カレンダーのeventクリック時、日付と同じ処理だが、データの取得元が異なるため分離
  const handleClickEvent = useCallback(
    async (e: EventClickArg | any) => {
      //初期表示以外の場合、現在選択されている日にちの背景をunsetする
      if (targetDayNumber !== 99) {
        const first_day_number = getTargetDay(currentMonthFirstDate);
        const current_date_element: HTMLElement =
          document.getElementsByClassName("fc-daygrid-day")[
            targetDayNumber + first_day_number
          ] as HTMLElement;
        //今日の日付の場合背景を黄色のままにするように分岐
        if (
          Number(current_date_element.dataset.date?.slice(-2)) ===
          Number(today.slice(-2))
        ) {
          current_date_element.style.backgroundColor =
            "rgba(255, 220, 40, 0.15)";
        } else {
          current_date_element.style.backgroundColor = "unset";
        }
      }

      e.el.parentNode.parentNode.parentNode.parentNode.style.backgroundColor =
        "#dbedff";
      const num = Number(Number(e.event.startStr.slice(-2)) - 1);
      //表示しているカレンダーが自分の場合(selectedUserが空)
      if (selectedUser.user_profile === 0) {
        const para: GET_DATE_RECORD_PARAMETERS = {
          user_id: loginUser.id,
          date: e.event.startStr,
        };
        await dispatch(fetchAsyncGetTimeRecord(para));
      }
      if (selectedUser.user_profile !== 0) {
        const para: GET_DATE_RECORD_PARAMETERS = {
          user_id: selectedUser.user_profile,
          date: e.event.startStr,
        };
        await dispatch(fetchAsyncGetTimeRecord(para));
      }
      await setTargetDayNumber(num);

      const newArray = records.filter(
        (record) => record.date === e.event.startStr
      );
      const newOriginalArray = originalRecords.filter(
        (record) => record.date === e.event.startStr
      );
      // const array = [...newArray, ...newOriginalArray];
      await setTmpDayRecords(newArray);
      await setTmpDayOriginalRecords(newOriginalArray);
      await dispatch(selectTargetDay(e.event.startStr));
    },
    [records, originalRecords, dispatch, targetDayNumber, targetMonth]
  );
  //tmpDayRecordsが変更された時、dayRecordsにセットする（画面表示用）
  useEffect(() => {
    dispatch(addDayRecord(tmpDayRecords));
  }, [tmpDayRecords, dispatch]);

  useEffect(() => {
    dispatch(addDayOriginalRecord(tmpDayOriginalRecords));
  }, [dispatch, tmpDayOriginalRecords]);

  //0埋め関数（初回レンダー時、日付が 7 になってしまう → 07 にする）
  const toDoubleDigits = (num: string) => {
    num += "";
    if (num.length === 1) {
      num = "0" + num;
    }
    return num;
  };
  //edit ボタンを押下した時の処理
  //editRecordへ対象のレコードを追加して、createRecordページへ遷移する
  const handleEditRecord = async (record: READ_RECORD) => {
    await dispatch(
      editRecord([
        {
          id: record.id,
          menu_id: record.menu_id,
          weight: record.weight,
          number_value: record.number_value,
          set_value: record.set_value,
          date: record.date,
        },
      ])
    );
    await dispatch(addIsQuickEditRecordFlg(true));
    if (record.menu_user_id === "0") {
      await dispatch(fetchAsyncGetTargetMenu(record.menu_id));
    }
    await history.push("/home/create/record");
  };
  const handleEditOriginalRecord = async (record: ORIGINAL_RECORD) => {
    await dispatch(
      editRecord([
        {
          id: record.id,
          menu_id: record.menu_id,
          weight: record.weight,
          number_value: record.number_value,
          set_value: record.set_value,
          date: record.date,
        },
      ])
    );
    await dispatch(addIsQuickEditRecordFlg(true));
    if (record.menu_user_id !== "0") {
      await dispatch(
        selectTargetMenu({
          id: record.menu_id,
          title: record.menu_title,
          part: record.menu_part_number,
          part_name: record.menu_part,
          type: record.menu_type_number,
          type_name: record.menu_type,
          color: record.menu_color_number,
          menu_color: record.menu_color,
          user_id: Number(record.menu_user_id),
        })
      );
    }
    await history.push("/home/create/record");
  };
  //modalの削除ボタン押下時
  const handleDeleteRecord = async () => {
    await setTmpDayRecords(initialState.dayRecords);
    if (deleteTarget.menu_user_id === "0") {
      await dispatch(fetchAsyncDeleteRecord(deleteTarget.id));
    }
    if (deleteTarget.menu_user_id !== "0") {
      await dispatch(fetchAsyncDeleteOriginalRecord(deleteTarget.id));
    }
    await setOpen(false);
    await setDeleteTarget({ id: 0, title: "", text: "", menu_user_id: "" });
  };

  useEffect(() => {
    // このeffectは初回レンダー時のみ呼ばれるeffect
    isFirstRender.current = true;
    dispatch(fetchAsyncLoginUser());
    let date = new Date();
    let targetDate = `${date.getFullYear()}-${toDoubleDigits(
      String(date.getMonth() + 1)
    )}-${toDoubleDigits(String(date.getDate()))}`;
    setTargetMonth(targetDate);
    setToday(targetDate);
    dispatch(selectTargetDay(targetDate));
  }, [dispatch]);

  useEffect(() => {
    if (isFirstRender.current) {
      // 初回レンダー判定
      isFirstRender.current = false;
    } else {
      //ページ表示時のレコード取得（今月のレコード）
      const fetchBootLoader = async () => {
        let first_date = getFirstDate(new Date());
        let last_date = getLastDate(new Date());
        //カレンダーの表示対象を判別 selectedUserにidが存在する場合、他ユーザのレコードを取得
        let target_user_id =
          selectedUser.user_profile !== 0
            ? selectedUser.user_profile
            : loginUser.id;
        const para = {
          user_id: target_user_id,
          date_after: `${first_date.getFullYear()}-${
            first_date.getMonth() + 1
          }-${first_date.getDate()}`,
          date_before: `${last_date.getFullYear()}-${
            last_date.getMonth() + 1
          }-${last_date.getDate()}`,
        };
        //表示しているカレンダーが自分の場合(selectedUserが空)
        if (selectedUser.user_profile === 0) {
          const timePara: GET_DATE_RECORD_PARAMETERS = {
            user_id: loginUser.id,
            date: targetDay,
          };
          await dispatch(fetchAsyncGetTimeRecord(timePara));
        }
        if (selectedUser.user_profile !== 0) {
          const timePara: GET_DATE_RECORD_PARAMETERS = {
            user_id: selectedUser.user_profile,
            date: targetDay,
          };
          await dispatch(fetchAsyncGetTimeRecord(timePara));
        }
        await setCurrentMonthFirstDate(first_date);
        await dispatch(fetchAsyncGetRecords(para));
        await dispatch(fetchAsyncGetOriginalRecords(para));
      };
      //画面表示時にレコードが存在しない場合、新規に取得
      fetchBootLoader();
    }
  }, [loginUser]);

  //レコードをeventへセット　→カレンダーへ表示させる
  useEffect(() => {
    setEvents([
      {
        title: "",
        start: "",
        color: "",
      },
    ]);
    records.map((record) =>
      setEvents((events) => [
        ...events,
        {
          title: record.menu_part,
          start: record.date,
          color: record.menu_color,
        },
      ])
    );
    originalRecords.map((record) =>
      setEvents((events) => [
        ...events,
        {
          title: record.menu_part,
          start: record.date,
          color: record.menu_color,
        },
      ])
    );
  }, [records, originalRecords]);

  //headerの戻るボタン
  const handleClickPrev = async () => {
    let backBtnElement: HTMLElement = document.getElementsByClassName(
      "fc-icon-chevron-left"
    )[0] as HTMLElement;
    const fetchBootLoader = async () => {
      let date_array: any = targetMonth.split("-");
      let date = new Date(date_array[0], date_array[1] - 1, date_array[2]);
      let prev_month = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        date.getDate()
      );

      let first_date = getFirstDate(prev_month);
      let last_date = getLastDate(prev_month);
      //カレンダーの表示対象を判別 selectedUserにidが存在する場合、他ユーザのレコードを取得
      let target_user_id =
        selectedUser.user_profile !== 0
          ? selectedUser.user_profile
          : loginUser.id;
      const para = {
        user_id: target_user_id,
        date_after: `${first_date.getFullYear()}-${
          first_date.getMonth() + 1
        }-${first_date.getDate()}`,
        date_before: `${last_date.getFullYear()}-${
          last_date.getMonth() + 1
        }-${last_date.getDate()}`,
      };
      await dispatch(fetchAsyncGetRecords(para));
      await dispatch(fetchAsyncGetOriginalRecords(para));
      await setCurrentMonthFirstDate(first_date);
      await setTargetMonth(
        `${first_date.getFullYear()}-${
          first_date.getMonth() + 1
        }-${first_date.getDate()}`
      );
    };
    //画面表示時にレコードが存在しない場合、新規に取得
    await setIsLoading(true);
    await fetchBootLoader();
    await unsetSelectDateColor();
    await backBtnElement.click();
    await setIsLoading(false);
  };
  //headerの次へボタン
  const handleClickNext = async () => {
    let backBtnElement: HTMLElement = document.getElementsByClassName(
      "fc-icon-chevron-right"
    )[0] as HTMLElement;
    const fetchBootLoader = async () => {
      let date_array: any = targetMonth.split("-");
      let date = new Date(date_array[0], date_array[1] - 1, date_array[2]);
      let next_month = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
      );
      let first_date = getFirstDate(next_month);
      let last_date = getLastDate(next_month);
      //カレンダーの表示対象を判別 selectedUserにidが存在する場合、他ユーザのレコードを取得
      let target_user_id =
        selectedUser.user_profile !== 0
          ? selectedUser.user_profile
          : loginUser.id;
      const para = {
        user_id: target_user_id,
        date_after: `${first_date.getFullYear()}-${
          first_date.getMonth() + 1
        }-${first_date.getDate()}`,
        date_before: `${last_date.getFullYear()}-${
          last_date.getMonth() + 1
        }-${last_date.getDate()}`,
      };
      await dispatch(fetchAsyncGetRecords(para));
      await dispatch(fetchAsyncGetOriginalRecords(para));
      await setTargetMonth(
        `${first_date.getFullYear()}-${
          first_date.getMonth() + 1
        }-${first_date.getDate()}`
      );
      await setCurrentMonthFirstDate(first_date);
    };
    //画面表示時にレコードが存在しない場合、新規に取得
    await setIsLoading(true);
    await fetchBootLoader();
    await unsetSelectDateColor();
    await backBtnElement.click();
    await setIsLoading(false);
  };

  //画面表示時に各stateをリセット
  //dayrecordsには当日日付のrecordをセットする。(初期表示)
  useEffect(() => {
    // dispatch(addDayRecordReset());
    dispatch(addDayRecord(initialState.dayRecords));
    dispatch(editRecord(initialState.editedRecord));
    dispatch(selectRecord(initialState.selectedRecord));
    dispatch(addDayOriginalRecord(initialState.dayOriginalRecords));
    const newArray = records.filter(
      (record) => record.date === targetDay && record.date !== ""
    );
    const newOriginalArray = originalRecords.filter(
      (record) => record.date === targetDay && record.date !== ""
    );
    newArray.length > 0 && setTmpDayRecords(newArray);
    newOriginalArray.length > 0 && setTmpDayOriginalRecords(newOriginalArray);
  }, [records, originalRecords]);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        component={Paper}
        elevation={2}
        className={classes.gridContainer}
      >
        {isLoading && (
          <div className={classes.circulContainer}>
            <CircularProgress />
          </div>
        )}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.modalContainer}>
              <div className={classes.modalText}>削除しますか？</div>
              <div className={classes.modalItem}>
                <ListItem
                  key={deleteTarget.id}
                  button
                  className={classes.listItem}
                >
                  <div>
                    <ListItemText
                      primary={deleteTarget.title}
                      className={classes.menuTitle}
                    />
                  </div>

                  <div className={classes.listItemSub}>
                    <ListItemText
                      disableTypography
                      primary={deleteTarget.text}
                      className={classes.body}
                    />
                  </div>
                </ListItem>
              </div>
              <div className={classes.modalBox}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.modalDeleteBtn}
                  onClick={handleDeleteRecord}
                >
                  削除
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={handleClose}
                >
                  キャンセル
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
        {selectedUser.user_profile !== 0 && (
          <Box display="flex" alignItems="center">
            <ArrowBackIcon onClick={backProfile} className={classes.back} />
            <Box
              display="flex"
              alignItems="center"
              className={classes.avatarContainer}
            >
              <Avatar
                className={classes.avatar}
                src={
                  selectedProfile?.results[0]?.img !== null
                    ? selectedProfile?.results[0]?.img
                    : undefined
                }
              />
              <div>{selectedUser.username}</div>
            </Box>
          </Box>
        )}
        <Paper className={classes.calendar}>
          <IconButton onClick={handleClickPrev} className={classes.arrowPrev}>
            <ArrowBackIosIcon fontSize="large" className={classes.color} />
          </IconButton>
          <IconButton onClick={handleClickNext} className={classes.arrowNext}>
            <ArrowForwardIosIcon fontSize="large" className={classes.color} />
          </IconButton>
          <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            events={filterEvents}
            initialView="dayGridMonth"
            headerToolbar={{
              left: "prev",
              center: "title",
              right: "next",
            }}
            height={450}
            editable={false}
            selectable={false}
            selectMirror={true}
            selectLongPressDelay={1}
            showNonCurrentDates={false}
            dateClick={handleClickDate}
            eventClick={handleClickEvent}
            timeZone="Asia/Tokyo"
            locale="ja"
            dayCellContent={(e) =>
              (e.dayNumberText = e.dayNumberText.replace("日", ""))
            }
          />
        </Paper>

        <Paper className={classes.root}>
          <div className={classes.color}>
            <span className={classes.day}>{targetDay}</span>
          </div>
          {timeRecord.id !== 0 && (
            <div className={classes.timeContainer}>
              <TimerIcon />
              {timeRecord.time_number} min
            </div>
          )}

          <div>
            {selectedUser.user_profile === 0 && (
              <IconButton
                onClick={handleClickAdd}
                className={classes.addBtnContainer}
              >
                <PlaylistAddIcon className={classes.addBtn} />
              </IconButton>
            )}
          </div>
        </Paper>
        <div className={classes.listContainer}>
          <List className={classes.listHeight}>
            {/* dayRecordsに初期値以外が存在していればレコードを表示 */}
            {dayRecords.length > 0 && dayRecords[0].id !== 0 ? (
              <>
                {dayRecords.map((record, index) => {
                  const labelId = `label ${record.id}`;
                  const weight = record.weight ? `${record.weight}kg` : "";
                  const rep =
                    record.number_value && record.menu_part !== "有"
                      ? `${record.number_value}rep`
                      : "";
                  const min =
                    record.menu_type === "time"
                      ? `${record.number_value}min`
                      : "";
                  const set = record.set_value ? `${record.set_value}set` : "";
                  const km =
                    record.menu_type === "km" ? `${record.number_value}km` : "";
                  const subText = `${weight} ${rep} ${km} ${min} ${set}`;

                  return (
                    <ListItem
                      key={record.id}
                      button
                      className={classes.listItem}
                    >
                      <div>
                        <ListItemText
                          id={labelId}
                          primary={record.menu_title}
                          className={classes.menuTitle}
                        />
                      </div>

                      <div className={classes.listItemSub}>
                        <ListItemText
                          disableTypography
                          primary={subText}
                          className={classes.body}
                        />
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <EditIcon
                              onClick={() => handleEditRecord(record)}
                            />
                          )}
                        </IconButton>
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <DeleteOutlineRoundedIcon
                              onClick={() => handleDeleteModal(record)}
                            />
                          )}
                        </IconButton>
                      </div>
                    </ListItem>
                  );
                })}
              </>
            ) : (
              ""
            )}
            {dayOriginalRecords.length > 0 && dayOriginalRecords[0].id !== 0 ? (
              <>
                {dayOriginalRecords.map((record, index) => {
                  const labelId = `label-original ${record.id}`;
                  const weight = record.weight ? `${record.weight}kg` : "";
                  const rep =
                    record.number_value &&
                    record.menu_type !== "time" &&
                    record.menu_type !== "km"
                      ? `${record.number_value}rep`
                      : "";
                  const min =
                    record.menu_type === "time"
                      ? `${record.number_value}min`
                      : "";
                  const set = record.set_value ? `${record.set_value}set` : "";
                  const km =
                    record.menu_type === "km" ? `${record.number_value}km` : "";
                  const subText = `${weight} ${rep} ${min} ${km} ${set}`;

                  return (
                    <ListItem
                      key={record.id}
                      button
                      className={classes.listItem}
                    >
                      <div>
                        <ListItemText
                          id={labelId}
                          primary={record.menu_title}
                          className={classes.menuTitle}
                        />
                      </div>

                      <div className={classes.listItemSub}>
                        <ListItemText
                          disableTypography
                          primary={subText}
                          className={classes.body}
                        />
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <EditIcon
                              onClick={() => handleEditOriginalRecord(record)}
                            />
                          )}
                        </IconButton>
                        <IconButton>
                          {selectedUser.user_profile === 0 && (
                            <DeleteOutlineRoundedIcon
                              onClick={() => handleDeleteModal(record)}
                            />
                          )}
                        </IconButton>
                      </div>
                    </ListItem>
                  );
                })}
              </>
            ) : (
              ""
            )}
          </List>
        </div>
      </Grid>
    </Grid>
  );
};

export default Home;
